import { all, call, put, takeLatest } from "redux-saga/effects";
import { Types } from "../../types";
import { AddHolidayErrorAction, AddHolidaySuccessAction, RemoveHolidayErrorAction, RemoveHolidaySuccessAction, UpdateHolidayErrorAction, UpdateHolidaySuccessAction, getHolidayErrorAction, getHolidaySuccessAction } from "../../actions/calendarHolidayAction";
import { addHolidayRequest, deleteHolidayRequest, getHolidayRequest, updateHolidayRequest } from "../apiRequests/calendarRequests";



function* getHolidayRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(getHolidayRequest, action.payload)
        yield put(
            getHolidaySuccessAction(response.data)
        )
    } catch (error: any) {
        yield put(
            getHolidayErrorAction({
                error: error.message
            })
        )
    }
}
function* addHolidayRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(addHolidayRequest, action.payload)
        yield put(
            AddHolidaySuccessAction()
        )
    } catch (error: any) {
        yield put(
            AddHolidayErrorAction({
                error: error.message
            })
        )
    }
}
function* updateHolidayRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(updateHolidayRequest, action.payload)
        yield put(
            UpdateHolidaySuccessAction()
        )
    } catch (error: any) {
        yield put(
            UpdateHolidayErrorAction({
                error: error.message
            })
        )
    }
}
function* removeHolidayRequestHandler(action: any) {
    try {
        const response: { data: any } = yield call(deleteHolidayRequest, action.payload)
        yield put(
            RemoveHolidaySuccessAction()
        )
    } catch (error: any) {
        yield put(
            RemoveHolidayErrorAction({
                error: error.message
            })
        )
    }
}



function* CalendarHolidaySaga() {


    yield all([takeLatest(Types.GET_HOLIDAY_REQUEST, getHolidayRequestHandler)]);
    yield all([takeLatest(Types.ADD_HOLIDAY_REQUEST, addHolidayRequestHandler)]);
    yield all([takeLatest(Types.UPDATE_HOLIDAY_REQUEST, updateHolidayRequestHandler)]);
    yield all([takeLatest(Types.REMOVE_HOLIDAY_REQUEST, removeHolidayRequestHandler)]);










}

export default CalendarHolidaySaga